var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    choicePadding: spacing.xSmall,
    choiceBorder: borders.widthSmall,
    choiceBorderColor: colors.ash,
    choiceBorderRadius: borders.radiusMedium,
    choiceBackgroundColor: colors.white
  };
};
export default generateComponentTheme;